import { makeEnvironmentProviders } from '@angular/core';
import { AUTH_SERVICE } from '@kikkz/shared/auth/util';
import { AuthFacade, AuthStore } from '@kikkz/shared/auth/data-access';
import { B04AuthService } from '../services/b04-auth.service';
import { B04AuthStore } from '../store/b04-auth.store';
import { B04AuthFacade } from '../facade/b04-auth.facade';

export function provideB04Auth() {
  return makeEnvironmentProviders([
    { provide: AUTH_SERVICE, useClass: B04AuthService },
    B04AuthStore,
    { provide: AuthStore, useExisting: B04AuthStore },
    B04AuthFacade,
    { provide: AuthFacade, useExisting: B04AuthFacade },
  ]);
}
